import styled from "styled-components";
import { color, typeStyle } from "@m/alchemy-theme";
export const Table = styled.table `
  min-width: 100%;
  position: relative;
  ${typeStyle("bodyS")};
  color: ${color("typeBody")};

  thead th {
    ${typeStyle("bodyM")};
    color: ${color("typeHeader")};
    vertical-align: bottom;
  }
`;
export const OverflowCssWrapper = styled.div `
  overflow: auto;
`;
